/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { styled } from '@mui/system';

import moQuestion, { changeQuestion, changeEight } from '../store';
import '../scss/common.scss';
import {
  BorderLinearProgress,
  DInput,
  NextButton,
  PrevButton,
} from '@/styled/button';
import { submitQuestion } from '@/styled/common';
import { isEmpty } from 'lodash';
import { observer } from 'mobx-react';

const EightQuestion = (props: any) => {
  const [type, setType] = useState('question');
  const [list1, setList1] = useState<any>([]);
  const [list2, setList2] = useState<any>([]);
  const [list3, setList3] = useState<any>([]);
  const [list4, setList4] = useState<any>([]);
  const [list5, setList5] = useState<any>([]);
  const { eightAnswer, prevtime } = moQuestion;
  const onSave = async () => {
    const result = await submitQuestion(
      `${prevtime}年各职能员工离职率`,
      eightAnswer,
      prevtime,
    );
    if (!isEmpty(result)) {
      const res1: any = [
        {
          name: '25分位',
          all:
            result.one && result.one.p25 ? `${result.one.p25}%` : '-',
          hight:
            result.two && result.two.p25 ? `${result.two.p25}%` : '-',
        },
        {
          name: '50分位',
          all:
            result.one && result.one.p50 ? `${result.one.p50}%` : '-',
          hight:
            result.two && result.two.p50 ? `${result.two.p50}%` : '-',
        },
        {
          name: '75分位',
          all:
            result.one && result.one.p75 ? `${result.one.p75}%` : '-',
          hight:
            result.two && result.two.p75 ? `${result.two.p75}%` : '-',
        },
        {
          name: '平均值',
          all:
            result.one && result.one.avg ? `${result.one.avg}%` : '-',
          hight:
            result.two && result.two.avg ? `${result.two.avg}%` : '-',
        },
      ];
      const res2: any = [
        {
          name: '25分位',
          all:
            result.three && result.three.p25 ?
              `${result.three.p25}%` :
              '-',
          hight:
            result.four && result.four.p25 ?
              `${result.four.p25}%` :
              '-',
        },
        {
          name: '50分位',
          all:
            result.three && result.three.p50 ?
              `${result.three.p50}%` :
              '-',
          hight:
            result.four && result.four.p50 ?
              `${result.four.p50}%` :
              '-',
        },
        {
          name: '75分位',
          all:
            result.three && result.three.p75 ?
              `${result.three.p75}%` :
              '-',
          hight:
            result.four && result.four.p75 ?
              `${result.four.p75}%` :
              '-',
        },
        {
          name: '平均值',
          all:
            result.three && result.three.avg ?
              `${result.three.avg}%` :
              '-',
          hight:
            result.four && result.four.avg ?
              `${result.four.avg}%` :
              '-',
        },
      ];
      const res3 = [
        {
          name: '25分位',
          all:
            result.five && result.five.p25 ?
              `${result.five.p25}%` :
              '-',
          hight:
            result.six && result.six.p25 ? `${result.six.p25}%` : '-',
        },
        {
          name: '50分位',
          all:
            result.five && result.five.p50 ?
              `${result.five.p50}%` :
              '-',
          hight:
            result.six && result.six.p50 ? `${result.six.p50}%` : '-',
        },
        {
          name: '75分位',
          all:
            result.five && result.five.p75 ?
              `${result.five.p75}%` :
              '-',
          hight:
            result.six && result.six.p75 ? `${result.six.p75}%` : '-',
        },
        {
          name: '平均值',
          all:
            result.five && result.five.avg ?
              `${result.five.avg}%` :
              '-',
          hight:
            result.six && result.six.avg ? `${result.six.avg}%` : '-',
        },
      ];
      const res4 = [
        {
          name: '25分位',
          all:
            result.seven && result.seven.p25 ?
              `${result.seven.p25}%` :
              '-',
          hight:
            result.eight && result.eight.p25 ?
              `${result.eight.p25}%` :
              '-',
        },
        {
          name: '50分位',
          all:
            result.seven && result.seven.p50 ?
              `${result.seven.p50}%` :
              '-',
          hight:
            result.eight && result.eight.p50 ?
              `${result.eight.p50}%` :
              '-',
        },
        {
          name: '75分位',
          all:
            result.seven && result.seven.p75 ?
              `${result.seven.p75}%` :
              '-',
          hight:
            result.eight && result.eight.p75 ?
              `${result.eight.p75}%` :
              '-',
        },
        {
          name: '平均值',
          all:
            result.seven && result.seven.avg ?
              `${result.seven.avg}%` :
              '-',
          hight:
            result.eight && result.eight.avg ?
              `${result.eight.avg}%` :
              '-',
        },
      ];
      const res5 = [
        {
          name: '25分位',
          all:
            result.nine && result.nine.p25 ?
              `${result.nine.p25}%` :
              '-',
          hight:
            result.ten && result.ten.p25 ? `${result.ten.p25}%` : '-',
        },
        {
          name: '50分位',
          all:
            result.nine && result.nine.p50 ?
              `${result.nine.p50}%` :
              '-',
          hight:
            result.ten && result.ten.p50 ? `${result.ten.p50}%` : '-',
        },
        {
          name: '75分位',
          all:
            result.nine && result.nine.p75 ?
              `${result.nine.p75}%` :
              '-',
          hight:
            result.ten && result.ten.p75 ? `${result.ten.p75}%` : '-',
        },
        {
          name: '平均值',
          all:
            result.nine && result.nine.avg ?
              `${result.nine.avg}%` :
              '-',
          hight:
            result.ten && result.ten.avg ? `${result.ten.avg}%` : '-',
        },
      ];
      setList1(res1);
      setList2(res2);
      setList3(res3);
      setList4(res4);
      setList5(res5);
    }
    setType('answer');
  };
  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className='allQuestion'>
      {type === 'question' ? (
        <section className='allContent'>
          <h2>二、离职率</h2>
          <h3>2.2 {prevtime}年各职能员工离职率</h3>
          <section className='commonHead'>
            <b>职能</b>
            <b>离职率%</b>
            <b>主动离职率%</b>
          </section>
          <section className='commonEdit'>
            <p>研发类</p>
            <DInput
              value={eightAnswer.one}
              onChange={(e: any) => {
                changeEight(e.target.value, 'one');
              }}/>
            <DInput
              value={eightAnswer.two}
              onChange={(e: any) => {
                changeEight(e.target.value, 'two');
              }}/>
          </section>
          <section className='commonEdit'>
            <p>生产&运营类</p>
            <DInput
              value={eightAnswer.three}
              onChange={(e: any) => {
                changeEight(e.target.value, 'three');
              }}/>
            <DInput
              value={eightAnswer.four}
              onChange={(e: any) => {
                changeEight(e.target.value, 'four');
              }}/>
          </section>
          <section className='commonEdit'>
            <p>市场销售类</p>
            <DInput
              value={eightAnswer.five}
              onChange={(e: any) => {
                changeEight(e.target.value, 'five');
              }}/>
            <DInput
              value={eightAnswer.six}
              onChange={(e: any) => {
                changeEight(e.target.value, 'six');
              }}/>
          </section>
          <section className='commonEdit'>
            <p>客服&技术支持类</p>
            <DInput
              value={eightAnswer.seven}
              onChange={(e: any) => {
                changeEight(e.target.value, 'seven');
              }}/>
            <DInput
              value={eightAnswer.eight}
              onChange={(e: any) => {
                changeEight(e.target.value, 'eight');
              }}/>
          </section>
          <section className='commonEdit'>
            <p>通用职能（财务/人事等）</p>
            <DInput
              value={eightAnswer.nine}
              onChange={(e: any) => {
                changeEight(e.target.value, 'nine');
              }}/>
            <DInput
              value={eightAnswer.ten}
              onChange={(e: any) => {
                changeEight(e.target.value, 'ten');
              }}/>
          </section>
          <p className='explanatory'>
            离职率 = 当年离职员工数 / （当年年初员工总数+当年入职员工数） *100%
          </p>
          <p className='explanatory'>
            主动离职率 = 该职能下当年主动离职员工数 / 该职能下当年年初员工总数
            *100%
          </p>
        </section>
      ) : (
        <section className='allContent'>
          <h2>二、离职率</h2>
          <h3>2.2 {prevtime}年员工离职率统计结果</h3>
          <section className='commonHead'>
            <b>分布</b>
            <b>离职率</b>
            <b>主动离职率</b>
          </section>
          <p className='commonTitle'>研发类</p>
          {list1?.map((res: any) => {
            return (
              <section className='commonShow' key={res.name}>
                <b>{res.name}</b>
                <b>{res.all}</b>
                <b>{res.hight}</b>
              </section>
            );
          })}
          <p className='commonTitle'>生产&运营类</p>
          {list2?.map((res: any) => {
            return (
              <section className='commonShow' key={res.name}>
                <b>{res.name}</b>
                <b>{res.all}</b>
                <b>{res.hight}</b>
              </section>
            );
          })}
          <p className='commonTitle'>市场销售类</p>
          {list3?.map((res: any) => {
            return (
              <section className='commonShow' key={res.name}>
                <b>{res.name}</b>
                <b>{res.all}</b>
                <b>{res.hight}</b>
              </section>
            );
          })}
          <p className='commonTitle'>客服&技术支持类</p>
          {list4?.map((res: any) => {
            return (
              <section className='commonShow' key={res.name}>
                <b>{res.name}</b>
                <b>{res.all}</b>
                <b>{res.hight}</b>
              </section>
            );
          })}
          <p className='commonTitle'>通用职能（财务/人事等）</p>
          {list5?.map((res: any) => {
            return (
              <section className='commonShow' key={res.name}>
                <b>{res.name}</b>
                <b>{res.all}</b>
                <b>{res.hight}</b>
              </section>
            );
          })}
        </section>
      )}
      <section className='btnGroup'>
        <section className='numProgress'>
          <p className='num'>
            <span>8</span> / 15
          </p>
          <BorderLinearProgress variant='determinate' value={(8 / 15) * 100} />
        </section>
        <PrevButton
          onClick={() => {
            changeQuestion(7);
          }}>
          上一题
        </PrevButton>
        {type === 'question' ? (
          <PrevButton
            onClick={() => {
              changeQuestion(9);
            }}>
            跳过此题
          </PrevButton>
        ) : (
          <PrevButton
            onClick={() => {
              setType('question');
            }}>
            重新填写
          </PrevButton>
        )}
        {type === 'question' ? (
          <NextButton
            onClick={onSave}
            disabled={
              !eightAnswer.one &&
              !eightAnswer.two &&
              !eightAnswer.three &&
              !eightAnswer.four &&
              !eightAnswer.five &&
              !eightAnswer.six &&
              !eightAnswer.seven &&
              !eightAnswer.eight &&
              !eightAnswer.nine &&
              !eightAnswer.ten
            }>
            保存查看结果
          </NextButton>
        ) : (
          <NextButton
            onClick={() => {
              changeQuestion(9);
            }}>
            下一题
          </NextButton>
        )}
      </section>
    </section>
  );
};

export default observer(EightQuestion);
